import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { AppMultiAccountComponent } from './app-multi-account/app-multi-account.component';
import { AppMultiAccountModule } from './app-multi-account/app-multi-account.module';

if (!environment.development) {
    enableProdMode();
}

const isMultiAccountEnabled: boolean = getIsMultiAccountEnabled();
bootstrap(isMultiAccountEnabled);


// Synchronous XHR — blocks until the gatekeeper response arrives, guaranteeing
// __isMultiAccountEnabled is set before bootstrap selects the correct app module.
// Skip the XHR entirely during Cypress e2e runs — Cypress injects window.Cypress,
// so we can detect it and default to false without hitting any endpoint.
function getIsMultiAccountEnabled(): boolean {
    if ((window as any).Cypress) {
        return false;
    }
        
    let isMultiAccountEnabled = false;

    try {
        const gatekeeperUrl =
            `${environment.ZCI_API_BASE_URL}${environment.ZCI_API_ENDPOINTS.GATEKEEPER_PUBLIC}` +
            `?featureId=MULTI_ACCOUNT`;
        const xhr = new XMLHttpRequest();
        xhr.open('GET', gatekeeperUrl, false); // false = synchronous
        xhr.withCredentials = true;
        xhr.send();
        isMultiAccountEnabled = Boolean(JSON.parse(xhr.responseText));
    } catch {
        isMultiAccountEnabled = false;
    }

    return isMultiAccountEnabled;
}

function bootstrap(isMultiAccount: boolean): void {
    const appRootComponent = isMultiAccount  ? AppMultiAccountComponent : AppComponent;
    const appRootModule = isMultiAccount ? AppMultiAccountModule : AppModule;

    bootstrapApplication(appRootComponent, {
        providers: [importProvidersFrom(appRootModule)],
    }).catch((err) => console.error(err));
}
